export const iconFontAwesomeHalloweenCat = (
	<i className="fa-solid fa-cat"></i>
);
